<template>
  <div class="tdesk-form">
    <div class="tdesk-primary-notice info">
      <i class="fal" aria-hidden="true" />
      Requesting purchase on invoice must be approved by {{ partnershipName }},
      therefore access to this course is not immediate. If immediate access is required please select to pay via credit card
    </div>

    <form-errors :errors="formErrors" />

    <div class="form-group required">
      <label for="invoice-type">Invoice Made Out To</label>
      <select
        id="invoice-type"
        v-model="localInvoiceType"
        @input="$emit('update:invoiceType', localInvoiceType)"
      >
        <option value="client">
          {{ clientName }}
        </option>
      </select>
    </div>

    <div>
      <button
        id="submit-invoice-request"
        class="tdesk-primary-button"
        :disabled="!localInvoiceType"
        @click="handleInvoiceRequestCreation"
      >
        <i class="fas fa-arrow-circle-right" />
        Place Order Via Invoice
      </button>
      <button
        class="tdesk-secondary-button"
        @click="$emit('back')"
      >
        Go Back
      </button>
    </div>
  </div>
</template>

<script>
import FormErrors from "../../../components/form_errors.vue";

export default {
  components: {FormErrors},
  props: {
    partnershipName: {type: String, required: true},
    invoiceType: {type: String, required: true, default: 'purchaser'},
    clientUserFullName: {type: String, required: true},
    clientName: {type: String, required: true},
    clientUserId: {type: String, required: true},
    partnerId: {type: String, required: true},
    courseId: {type: String, required: true},
    participants: { type: Array, required: true },
    organizer: { type: Object, required: true },
    pricePerEnrol: { type: String, required: true },
  },
  emits: ['update:invoiceType', 'paymentComplete', 'back'],
  data() {
    return {
      localInvoiceType: 'client',
      formErrors: [],
    };
  },
  watch: {
    invoiceType(newValue) {
      this.localInvoiceType = newValue;
    },
  },
  methods: {
    handleInvoiceRequestCreation() {
      axios.post(
        Routes.client_users_lms_courses_multi_user_invoice_requests_path(),
        {
          lms_course_id: this.courseId,
          user_information: this.participants,
          organizer_information: this.organizer,
          partnership_id: this.partnerId,
          client_user_id: this.clientUserId,
          price_per_enrol: this.pricePerEnrol,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        },
      ).then(() => {
        this.$emit('paymentComplete');
      }).catch((error) => {
        if (error.response?.data?.errors) {
          this.formErrors = error.response.data.errors;
        } else {
          this.formErrors = ['An error occurred. Please try again or contact support if this issue persists'];
        }
      });
    },
  },
};
</script>
